import RoundButton from 'features/shared/components/buttons/RoundButton';
import DateFormatter from 'features/shared/components/formatters/DateFormatter';
import React from 'react';
import { useTranslation } from 'react-i18next';
import ReactionSimplifiedDTO from '../dtos/ReactionSimplifiedDTO';
import { ReactionSender } from '../enums/reactionSender';

interface Props {
  reaction: ReactionSimplifiedDTO;
  openReaction: (reactionId: string) => Promise<void>
}

const RequirementReaction = ({ reaction, openReaction }: Props) => {
  // translation
  const { t } = useTranslation(["requirements\\enums\\reactionSender"]);

  // helpers
  const getSenderColor = () => {
    switch (reaction.sender) {
      case ReactionSender.Customer:
        return "info";
      case ReactionSender.Supplier:
        return "warning";
      default:
        return "white";
    } 
  }

  // handlers
  const openReactionHandler = () => {
    if (reaction.reactionId) {
      openReaction(reaction.reactionId.toString())
    }
  }

  // render
  return (
    <div className="row no-gutters align-items-center">
      <div className="col">
        <div className="text-truncate">
          {reaction.reactionText}
        </div>
        <div className="d-flex text-muted small">
          <DateFormatter date={reaction.reactionDate!} formatOptions={{ hour: "numeric", minute: "numeric" }} />
          <div className="d-flex align-items-center ml-2">
            <span className={`d-inline-block rounded-circle p-1 mr-1 bg-${getSenderColor()}`}></span>
            <span className={`text-${getSenderColor()} text-truncate d-inline-block`}>
              {t(reaction.sender || "")}
            </span>
          </div>
          
        </div>
      </div>
      <div className="col-auto pl-3">
        <RoundButton onClickHandler={openReactionHandler} />
      </div>
    </div>
  )
}

export default RequirementReaction;
